<template>
  <div>
    <v-card class="text-xs-center mt-5" hover>
      <div style="position: absolute; right: 3px; top: 3px">
        <div>
          <v-btn
            flat
            icon
            color="grey"
            @click="editPasswordDialog = true"
            class="mr-0"
            v-if="userAuthClass"
          >
            <v-icon>lock</v-icon>
          </v-btn>
          <v-btn flat icon color="grey" @click="editDialog = true" v-if="userAuthClass">
            <v-icon>edit</v-icon>
          </v-btn>
        </div>
      </div>

      <div class>
        <v-avatar :color="color" size="66" class="overlap-avatar">
          <span class="white--text headline">{{letter.toUpperCase()}}</span>
        </v-avatar>
      </div>

      <v-card-text>
        <div class="pb-3 pt-3">
          <h5 class="subheading font-weight-regular text-capitalize">{{user.name}}</h5>
          <div class="grey--text text-capitalize">
            <span>{{user.userAuthClass.name}}</span>
          </div>
        </div>
        <div class="pb-4 vertical-center-container">
          <h5
            class="subheading font-weight-regular grey--text text--darken-1 truncate"
          >{{user.email}}</h5>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn flat icon color="grey" :href="'tel:'+user.contactPhone" v-if="!!user.contactPhone">
          <v-icon>phone</v-icon>
        </v-btn>
        <v-btn flat icon color="grey" :href="'mailto:'+user.email" v-if="!!user.email">
          <v-icon>mail</v-icon>
        </v-btn>

        <v-spacer></v-spacer>
        <v-btn flat icon color="red lighten-3" @click="deleteDialog = true" v-if="userAuthClass">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-card-actions>
      <slot name="parentActions"></slot>
      <div class="card-divider grey lighten-2" style="margin-top: 0px;"></div>

      <div class="card-footer text-xs-left">
        <time-ago class="grey--text" :time="user.updatedAt" needsParse updated>
          <v-icon small color="grey" slot="icon" class="mr-2">access_time</v-icon>
        </time-ago>
      </div>
      <div style="width: 100%; height: 2px;" :class="color"></div>
    </v-card>

    <!--EDIT VEHICLE DIALOG -->
    <v-dialog v-model="editDialog" max-width="700px" @keydown.esc="editDialog = false">
      <edit-user :user="user" @close="editDialog = false"></edit-user>
    </v-dialog>

    <!--PASSWORD CHANGE DIALOG -->
    <v-dialog
      v-model="editPasswordDialog"
      max-width="700px"
      @keydown.esc="editPasswordDialog = false"
    >
      <change-password :user="user" @close="editPasswordDialog = false"></change-password>
    </v-dialog>

    <!-- DELETE CONFIRMATION DIALOG -->
    <v-dialog v-model="deleteDialog" max-width="400px" @keydown.esc="deleteDialog = false">
      <v-card>
        <v-card-title class="headline">
          <span>
            Really delete?
            <span class="grey--text subheading">- {{user.name}}</span>
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" flat @click="deleteUser(); deleteDialog = false">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import UserService from "@/services/requests/userService";
import getColorFromChar from "@/services/helpers/getColorFromChar";
import EditUser from "@/components/users/editUser";
import ChangePassword from "@/components/users/changePassword";
import DisplaySnack from "@/services/mixins/displaySnack";

export default {
  mixins: [DisplaySnack],
  data() {
    return {
      editDialog: false,
      editPasswordDialog: false,
      deleteDialog: false
    };
  },
  methods: {
    deleteUser() {
      var user = this.user;
      UserService.deleteUser(user.id)
        .then(result => {
          //console.log(result.data);
          this.$store.commit("users/deleteFromArrayStateByValue", {
            prop: "users",
            value: user
          });
          this.snack({ text: "User was deleted!", color: "yellow" });
        })
        .catch(err => {
          //console.log("An error occured");
          this.snackError();
        });
    }
  },
  props: {
    user: Object,
    index: Number
  },
  computed: {
    color() {
      return getColorFromChar(this.user.name.charCodeAt(0));
    },
    letter() {
      return this.user.name.charAt(0);
    },
    passwordConfirmationDialog: Store.getSet({
      store: "users",
      prop: "passwordConfirmationDialog"
    })
  },
  components: {
    EditUser,
    ChangePassword
  }
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
.overlap-avatar {
  margin-top: -48px;
  border: 6px solid #eee;
  border-color: #eee !important;
}

.rounded {
  border-radius: 10px;
}
</style>
